<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <link-modal
      v-if="chatData"
      :store-module-name="STORE_MODULE_NAME"
      :data-id="dataId"
      :user-id="chatData.userInfo.userId"
      :is-link-modal-active.sync="isLinkModalActive"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-row
        class="messenger-container mt-2"
        no-gutters
      >
        <b-col md="4">
          <b-card
            v-if="$ability.can('read', this.$route.meta.resource)"
            class="chat-widget rounded-0"
            no-body
          >
            <b-row>
              <b-col>
                <b-row class="px-1 mt-1">
                  <b-col>
                    <h2>{{ $t('Chat') }}</h2>

                  </b-col>
                  <b-col>

                    <b-row>
                      <b-col md="6">
                        <v-select
                          v-model="userId"
                          size="sm"
                          label="name"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="userData"
                          :reduce="userData => userData._id"
                          :clearable="true"
                          class="select-size-sm"
                          :filterable="true"
                          :placeholder="$t('Search by name')"
                          @search="onSearchUser"
                          @input="onUserSelect"
                        >
                          <div
                            slot="list-footer"
                            class="m-1"
                          >
                            <b-row>
                              <b-col cols="4">
                                <b-button
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="info"
                                  block
                                  :disabled="currentPageUser <= 1 ? true : false"
                                  @click="nextPageUser(currentPageUser - 1)"
                                >
                                  <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                  />
                                </b-button>
                              </b-col>
                              <b-col cols="4">
                                <b-button
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="primary"
                                  block
                                  disabled
                                >
                                  {{ currentPageUser }}
                                </b-button>
                              </b-col>
                              <b-col cols="4">
                                <b-button
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="info"
                                  block
                                  :disabled="currentPageUser * perPageUser >= queriedItemsUser
                                    ? true
                                    : false
                                  "
                                  @click="nextPageUser(currentPageUser + 1)"
                                >
                                  <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                  />
                                </b-button>
                              </b-col>
                            </b-row>
                          </div>
                        </v-select>
                      </b-col>
                      <b-col md="3">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          v-b-tooltip.hover.top="$t('Create Chat')"
                          variant="primary"
                          size="sm"
                          block
                          @click="createChat()"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </b-col>
                      <b-col md="3">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          v-b-tooltip.hover.top="$t('Broadcast Message')"
                          variant="info"
                          size="sm"
                          block
                          @click="isBroadcastModalActive = true"
                        >
                          <feather-icon icon="RadioIcon" />
                        </b-button>
                      </b-col>
                    </b-row>

                  </b-col>
                </b-row>

              </b-col>

              <b-col
                cols="12"
                class="b-col-custom"
              >
                <div class="d-flex align-items-center justify-content-end mb-1 px-1">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-flex"
                    :placeholder="$t('Search') + '...'"
                    @input="typing($event)"
                  />
                </div>
              </b-col>
            </b-row>
            <b-table
              ref="refUserListTable"
              striped
              responsive
              class="position-relative hide-header"
              :items="respData"
              :fields="tableColumns"
              primary-key="_id"
              show-empty
              :empty-text="$t('No matching records found')"
              style="height: 55vh;"
              :show-head="false"
            >
              <!-- Column: Images -->
              <template #cell(pin)="data">
                <b-row @click="pinChat(data.item)">
                  <feather-icon
                    v-if="data.item.pin"
                    icon="StarIcon"
                    size="18"
                    style="color:red"
                  />
                  <feather-icon
                    v-else
                    icon="StarIcon"
                    size="18"
                    style="color:grey"
                  />
                </b-row>
              </template>
              <template #cell(image)="data">
                <b-link @click="openChat(data.item)">

                  <b-row>
                    <b-col cols="2">
                      <b-avatar
                        size="45px"
                        :src="data.item.userData.image"
                      />
                    </b-col>
                    <b-col cols="9">
                      <b-card-text>{{ data.item.userData.firstName }}
                        {{ data.item.userData.lastName }}</b-card-text>
                      <b-card-text>{{
                        data.item.message.staffId != null
                          ? $t('You')
                          : data.item.userData.firstName
                      }} :
                        {{
                          data.item.message.type === 0
                            ? data.item.message.message
                            : data.item.message.type === 5 ?
                              $t('Send Link')
                              : $t('Send pictures')
                        }} · {{ getTimeAgo(data.item.updated) }}</b-card-text>
                    </b-col>
                    <b-col
                      cols="1"
                      @click.stop="pinChat(data.item)"
                    >
                      <feather-icon
                        v-if="data.item.pin"
                        icon="StarIcon"
                        size="18"
                        style="color:yellow"
                      />
                      <feather-icon
                        v-else
                        icon="StarIcon"
                        size="18"
                        style="color:grey"
                      />
                    </b-col>
                  </b-row>
                </b-link>

              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">{{ currentPage * perPage - (perPage - 1) }} -
                    {{
                      queriedItems - currentPage * perPage > 0
                        ? currentPage * perPage
                        : queriedItems
                    }}
                    {{ $t('of') }} {{ queriedItems }}</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="queriedItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="nextPage"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col md="8">
          <div v-if="chatData">
            <b-card
              v-if="$ability.can('read', this.$route.meta.resource)"
              class="chat-widget rounded-0"
              no-body
            >
              <b-card-header class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <b-avatar
                    size="34"
                    :src="chatData.userInfo.image"
                    class="mr-50 badge-minimal"
                    badge
                    badge-variant="success"
                  />
                  <div>
                    <h5 class="mb-0">
                      {{ chatData.userInfo.firstName }}
                      {{ chatData.userInfo.lastName }}
                    </h5>
                  </div>
                </div>

                <!-- Customer WhatsApp binding display -->
                <div class="d-flex align-items-center">
                  <b-badge
                    v-if="chatData.userInfo.whatsappNumber"
                    variant="light-success"
                    class="cursor-pointer py-50 px-75 d-flex align-items-center"
                    @click="openWhatsappEditModal"
                  >
                    <feather-icon icon="MessageSquareIcon" size="14" class="mr-25" />
                    <span>WhatsApp: {{ chatData.userInfo.whatsappNumber }}</span>
                    <feather-icon icon="Edit2Icon" size="12" class="ml-50" />
                  </b-badge>
                  <b-button
                    v-else
                    variant="outline-success"
                    size="sm"
                    class="d-flex align-items-center"
                    @click="openWhatsappEditModal"
                  >
                    <feather-icon icon="PlusIcon" size="14" class="mr-25" />
                    <span>{{ $t('ผูกเบอร์ WhatsApp') }}</span>
                  </b-button>
                </div>
              </b-card-header>

              <section class="chat-app-window">
                <!-- User Chat Area -->
                <vue-perfect-scrollbar
                  ref="refChatLogPS"
                  :settings="perfectScrollbarSettings"
                  class="user-chats scroll-area"
                  style="height: 57.5vh;"
                >
                  <chat-log
                    :chat-data="chatData"
                    :image-view.sync="imageView"
                    :show-modal.sync="showModal"
                    :profile-user-avatar="menuService == 'franchise'
                      ? getFranchiseData.logo
                      : menuService == 'company'
                        ? getCompanyData.logo
                        : menuService == 'e-commerce'
                          ? getApplicationData.logo
                          : require('@/assets/images/avatars/10.png')
                    "
                  />
                </vue-perfect-scrollbar>

                <!-- Message Input -->
                <b-form
                  class="chat-app-form"
                  @submit.prevent="sendMessage"
                >
                  <!-- Channel Selection Bar -->
                  <div class="d-flex align-items-center justify-content-between mb-50 px-1 pt-50 bg-light rounded-top">
                    <div class="d-flex align-items-center">
                      <small class="font-weight-bold text-muted mr-1">{{ $t('ส่งผ่านช่องทาง') }}:</small>
                      <b-form-radio-group
                        v-model="sendChannel"
                        buttons
                        button-variant="outline-primary"
                        size="sm"
                      >
                        <b-form-radio value="app">
                          📱 App Chat
                        </b-form-radio>
                        <b-form-radio value="whatsapp">
                          💬 WhatsApp
                        </b-form-radio>
                      </b-form-radio-group>
                    </div>
                    <div v-if="sendChannel === 'whatsapp'">
                      <b-badge variant="success" class="px-50 py-25">
                        <feather-icon icon="SendIcon" size="12" class="mr-25" />
                        {{ $t('ส่งตรงไป WhatsApp ลูกค้า') }}
                      </b-badge>
                    </div>
                  </div>

                  <b-input-group class="form-send-message">
                    <b-form-input
                      v-model="chatInputMessage"
                      :placeholder="sendChannel === 'whatsapp' ? $t('พิมพ์ข้อความเพื่อส่งไปยัง WhatsApp ลูกค้า...') : 'Aa'"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="warning"
                        @click="addLink()"
                      >
                        <feather-icon
                          icon="LinkIcon"
                          size="16"
                        />
                      </b-button>
                      <b-button
                        variant="success"
                        @click="$refs.refInputEl.$el.click()"
                      >
                        📎
                      </b-button>
                      <b-form-file
                        ref="refInputEl"
                        accept=".webp, .jpeg, .jpg, .png, .gif"
                        :hidden="true"
                        plain
                        @change="inputImageRenderer"
                      />
                      <b-button
                        :variant="sendChannel === 'whatsapp' ? 'success' : 'primary'"
                        type="submit"
                      >
                        {{ sendChannel === 'whatsapp' ? 'WhatsApp ↵' : '↵' }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form>
              </section>
            </b-card>

            <!-- WhatsApp Edit Modal -->
            <b-modal
              id="modal-whatsapp-edit"
              v-model="isEditingWhatsappModal"
              :title="$t('ผูกเบอร์ WhatsApp ของลูกค้า')"
              :ok-title="$t('บันทึก')"
              :cancel-title="$t('ยกเลิก')"
              centered
              @ok="handleSaveWhatsappNumber"
            >
              <b-form-group :label="$t('เบอร์โทรศัพท์ WhatsApp ( e.g. +66812345678 หรือ 0812345678 )')">
                <b-form-input
                  v-model="whatsappNumberInput"
                  placeholder="+66812345678"
                  type="tel"
                />
                <small class="text-muted mt-50 d-block">
                  * ระบบจะใช้เบอร์นี้ในการส่งข้อความ/รูปภาพ/ลิงก์ จากหน้าแชทไปยัง WhatsApp ของลูกค้าโดยตรง
                </small>
              </b-form-group>
            </b-modal>

            <b-modal
              id="modal-center"
              v-model="showModal"
              centered
              hide-footer
              size="lg"
            >
              <b-img
                :src="imageView != ''
                  ? imageView
                  : require('@/assets/images/blank/no_image.png')
                "
                style="width: 100%;"
                :alt="'Chat'"
              />
            </b-modal>
            <!-- Broadcast Modal -->
            <b-modal
              id="modal-broadcast"
              v-model="isBroadcastModalActive"
              :title="$t('Broadcast Message (ข้อความกระจาย)')"
              :ok-title="$t('Send Broadcast')"
              :ok-disabled="broadcastLoading || !isBroadcastFormValid"
              :cancel-title="$t('Cancel')"
              size="lg"
              centered
              @ok="handleBroadcast"
              @show="onBroadcastModalShow"
            >
              <b-form>
                <!-- 1. Recipient Scope Selection -->
                <b-form-group :label="$t('Select Recipients (เลือกผู้รับ)')" class="font-weight-bold">
                  <b-form-radio-group
                    v-model="broadcastRecipientType"
                    name="broadcast-recipient-type"
                    buttons
                    button-variant="outline-primary"
                    size="sm"
                    class="w-100 mb-1 d-flex"
                  >
                    <b-form-radio value="all" class="flex-fill text-center">
                      <feather-icon icon="UsersIcon" class="mr-25" />
                      {{ $t('All Customers (ทั้งหมด)') }}
                    </b-form-radio>
                    <b-form-radio value="group" class="flex-fill text-center">
                      <feather-icon icon="UserCheckIcon" class="mr-25" />
                      {{ $t('By Member Group (ตามกลุ่มลูกค้า)') }}
                    </b-form-radio>
                    <b-form-radio value="tag" class="flex-fill text-center">
                      <feather-icon icon="TagIcon" class="mr-25" />
                      {{ $t('By Chat Status (ตามแท็ก/สถานะ)') }}
                    </b-form-radio>
                  </b-form-radio-group>

                  <!-- Sub-options for Group -->
                  <div v-if="broadcastRecipientType === 'group'" class="p-1 border rounded bg-light mb-1">
                    <label class="small text-muted font-weight-bold mb-50">{{ $t('Select Member Groups') }}:</label>
                    <div v-if="memberGroupOptions.length > 0">
                      <b-form-checkbox-group
                        v-model="broadcastSelectedGroups"
                        :options="memberGroupOptions"
                        name="broadcast-member-groups"
                        stacked
                      />
                    </div>
                    <div v-else class="text-muted small">
                      {{ $t('Loading groups...') }}
                    </div>
                  </div>

                  <!-- Sub-options for Tag/Status -->
                  <div v-if="broadcastRecipientType === 'tag'" class="p-1 border rounded bg-light mb-1">
                    <label class="small text-muted font-weight-bold mb-50">{{ $t('Select Chat Statuses') }}:</label>
                    <b-form-checkbox-group
                      v-model="broadcastSelectedTags"
                      name="broadcast-chat-tags"
                    >
                      <b-form-checkbox value="open" class="mr-1">
                        <b-badge variant="light-success">{{ $t('Open (ข้อความใหม่)') }}</b-badge>
                      </b-form-checkbox>
                      <b-form-checkbox value="hold" class="mr-1">
                        <b-badge variant="light-warning">{{ $t('Hold (รอดำเนินการ)') }}</b-badge>
                      </b-form-checkbox>
                      <b-form-checkbox value="review">
                        <b-badge variant="light-info">{{ $t('Review (ให้คะแนน)') }}</b-badge>
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </div>
                </b-form-group>

                <!-- 2. Multi-Language Messages -->
                <b-form-group :label="$t('Message Content (ข้อความหลายภาษา)')" class="font-weight-bold">
                  <b-tabs nav-class="nav-justified" active-nav-item-class="font-weight-bold text-primary">
                    <!-- Thai -->
                    <b-tab title="🇹🇭 ไทย (Thai)" active>
                      <b-form-textarea
                        v-model="broadcastMessages.th"
                        :placeholder="$t('พิมพ์ข้อความภาษาไทย...')"
                        rows="3"
                        max-rows="6"
                        class="mt-1"
                        :disabled="broadcastLoading"
                      />
                    </b-tab>
                    <!-- English -->
                    <b-tab title="🇬🇧 English">
                      <b-form-textarea
                        v-model="broadcastMessages.en"
                        :placeholder="$t('Type message in English...')"
                        rows="3"
                        max-rows="6"
                        class="mt-1"
                        :disabled="broadcastLoading"
                      />
                    </b-tab>
                    <!-- Arabic -->
                    <b-tab title="🇸🇦 العربية (Arabic)">
                      <b-form-textarea
                        v-model="broadcastMessages.ar"
                        :placeholder="$t('اكتب الرسالة باللغة العربية...')"
                        rows="3"
                        max-rows="6"
                        class="mt-1 text-right"
                        dir="rtl"
                        :disabled="broadcastLoading"
                      />
                    </b-tab>
                  </b-tabs>
                </b-form-group>

                <!-- 3. Attachments (Image & Link) -->
                <b-form-group :label="$t('Attachments (ไฟล์แนบ/ลิงก์)')" class="font-weight-bold">
                  <!-- Image Attachment -->
                  <div class="mb-1 p-1 border rounded">
                    <b-form-checkbox v-model="enableBroadcastImage">
                      <feather-icon icon="ImageIcon" class="mr-25" />
                      {{ $t('Attach Image (แนบรูปภาพ)') }}
                    </b-form-checkbox>
                    <div v-if="enableBroadcastImage" class="mt-1 pl-2">
                      <b-input-group class="mb-50">
                        <b-form-input
                          v-model="broadcastImageUrl"
                          :placeholder="$t('Direct Image URL (e.g. https://domain.com/image.png)')"
                          size="sm"
                        />
                        <b-input-group-append>
                          <b-button
                            variant="outline-primary"
                            size="sm"
                            @click="$refs.refBroadcastImageInput.$el.click()"
                            :disabled="uploadingBroadcastImage"
                          >
                            <b-spinner v-if="uploadingBroadcastImage" small class="mr-25" />
                            <feather-icon v-else icon="UploadIcon" class="mr-25" />
                            {{ $t('Upload Image') }}
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-file
                        ref="refBroadcastImageInput"
                        accept=".webp, .jpeg, .jpg, .png, .gif"
                        :hidden="true"
                        plain
                        @change="handleBroadcastImageUpload"
                      />
                      <div v-if="broadcastImageUrl" class="mt-50">
                        <b-img :src="broadcastImageUrl" thumbnail height="80" class="rounded" />
                      </div>
                    </div>
                  </div>

                  <!-- Link Attachment -->
                  <div class="p-1 border rounded">
                    <b-form-checkbox v-model="enableBroadcastLink">
                      <feather-icon icon="LinkIcon" class="mr-25" />
                      {{ $t('Attach Link (แนบลิงก์)') }}
                    </b-form-checkbox>
                    <div v-if="enableBroadcastLink" class="mt-1 pl-2">
                      <b-form-input
                        v-model="broadcastLinkTitle"
                        :placeholder="$t('Link Title (ชื่อลิงก์ e.g. ดูรายละเอียดเพิ่มเติม)')"
                        size="sm"
                        class="mb-50"
                      />
                      <b-form-input
                        v-model="broadcastLinkUrl"
                        :placeholder="$t('Link URL (URL e.g. https://bytematrix.co.th)')"
                        size="sm"
                      />
                    </div>
                  </div>
                </b-form-group>

                <div v-if="broadcastLoading" class="text-center my-1">
                  <b-spinner label="Broadcasting..." variant="primary" />
                  <div class="small text-muted mt-50">{{ $t('กำลังส่งข้อความกระจายไปยังลูกค้าที่เลือก...') }}</div>
                </div>
              </b-form>
            </b-modal>

            <!-- Broadcast Summary Modal -->
            <b-modal
              id="modal-broadcast-summary"
              v-model="isBroadcastSummaryModalActive"
              :title="$t('Broadcast Summary (สรุปผลการส่ง)')"
              ok-only
              :ok-title="$t('Done (เรียบร้อย)')"
              centered
              ok-variant="success"
            >
              <div class="text-center my-1">
                <div class="mb-1">
                  <b-avatar size="56" variant="light-success">
                    <feather-icon icon="CheckIcon" size="32" />
                  </b-avatar>
                </div>
                <h4 class="text-success font-weight-bold mb-1">{{ $t('Broadcast Sent Successfully!') }}</h4>
                <p class="text-muted small">{{ $t('สรุปรายการส่งข้อความกระจายไปยังห้องแชทของลูกค้า') }}</p>
              </div>

              <b-row class="mb-2 text-center">
                <b-col cols="4">
                  <div class="border rounded p-1">
                    <h3 class="mb-0 font-weight-bolder text-primary">{{ broadcastSummary.totalTarget }}</h3>
                    <small class="text-muted">{{ $t('Total Target') }}</small>
                  </div>
                </b-col>
                <b-col cols="4">
                  <div class="border rounded p-1 bg-light-success">
                    <h3 class="mb-0 font-weight-bolder text-success">{{ broadcastSummary.successCount }}</h3>
                    <small class="text-success">{{ $t('Sent Success') }}</small>
                  </div>
                </b-col>
                <b-col cols="4">
                  <div class="border rounded p-1 bg-light-danger">
                    <h3 class="mb-0 font-weight-bolder text-danger">{{ broadcastSummary.failedCount }}</h3>
                    <small class="text-danger">{{ $t('Failed') }}</small>
                  </div>
                </b-col>
              </b-row>

              <div v-if="broadcastSummary.recipients && broadcastSummary.recipients.length > 0">
                <label class="font-weight-bold small text-muted mb-50">{{ $t('Recipient List (รายชื่อผู้รับ)') }}:</label>
                <div class="border rounded p-1" style="max-height: 180px; overflow-y: auto;">
                  <div
                    v-for="(rec, index) in broadcastSummary.recipients"
                    :key="index"
                    class="d-flex justify-content-between align-items-center py-25 border-bottom"
                  >
                    <span class="small font-weight-bold">{{ rec.name || 'User ' + rec.userId }}</span>
                    <b-badge :variant="rec.status === 'success' ? 'light-success' : 'light-danger'">
                      {{ rec.status === 'success' ? $t('Success') : $t('Failed') }}
                    </b-badge>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <div v-else>
            <b-card
              border-variant="primary"
              :header="$t('Chat')"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
              style="height: 57vh;"
              class="text-center"
            >
              <b-card-text> {{ $t('Please select a user') }}</b-card-text>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BLink,
  BAvatar,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BDropdown,
  BOverlay,
  BCardText,
  BNavItemDropdown,
  BForm,
  BCardHeader,
  BInputGroup,
  BFormFile,
  BNavbarNav,
  BDropdownItem,
  BInputGroupAppend,
  BFormGroup,
  BFormTextarea,
  BSpinner,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckboxGroup,
  BFormCheckbox,
  BTabs,
  BTab,
  BBadge,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/eCommerce/chat'
import debounce from 'debounce'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ChatLog from './components/ChatLog.vue'
import LinkModal from './LinkModal.vue'

const STORE_MODULE_NAME = 'chat'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    BLink,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    // eslint-disable-next-line vue/no-unused-components
    BDropdown,
    // eslint-disable-next-line vue/no-unused-components
    BDropdownItem,
    BOverlay,
    BCardText,
    BCardHeader,
    // eslint-disable-next-line vue/no-unused-components
    BNavbarNav,
    BForm,
    BInputGroup,
    // eslint-disable-next-line vue/no-unused-components
    BNavItemDropdown,
    BFormFile,
    BInputGroupAppend,
    BFormGroup,
    BFormTextarea,
    BSpinner,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckboxGroup,
    BFormCheckbox,
    BTabs,
    BTab,
    BBadge,
    BListGroup,
    BListGroupItem,

    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    VuePerfectScrollbar,
    ChatLog,
    LinkModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      currentPage: 1,
      searchQuery: '',
      perPage: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 30,
      currentPageUser: 1,
      searchQueryUser: '',
      perPageUser: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 30,
      userId: '',
      isSidebarActive: false,
      sidebarData: {},
      show: false,
      dataId: null,
      chatType: 'roomId', // Default chat type
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
        wheelPropagation: false,
      },
      showModal: false,
      chatInputMessage: '',
      image: '',
      imageView: '',
      isLinkModalActive: false,
      isBroadcastModalActive: false,
      isBroadcastSummaryModalActive: false,
      broadcastMessageText: '',
      broadcastLoading: false,
      broadcastRecipientType: 'all',
      broadcastSelectedGroups: [],
      broadcastSelectedTags: ['open', 'hold', 'review'],
      memberGroupOptions: [],
      broadcastMessages: {
        th: '',
        en: '',
        ar: '',
      },
      enableBroadcastImage: false,
      broadcastImageUrl: '',
      uploadingBroadcastImage: false,
      enableBroadcastLink: false,
      broadcastLinkTitle: '',
      broadcastLinkUrl: '',
      broadcastSummary: {
        totalTarget: 0,
        successCount: 0,
        failedCount: 0,
        recipients: [],
      },
      now: new Date(),
      intervalId: null,
      sendChannel: 'app',
      whatsappNumberInput: '',
      isEditingWhatsappModal: false,
    }
  },
  computed: {
    isBroadcastFormValid() {
      const hasText =
        (this.broadcastMessages.th && this.broadcastMessages.th.trim().length > 0) ||
        (this.broadcastMessages.en && this.broadcastMessages.en.trim().length > 0) ||
        (this.broadcastMessages.ar && this.broadcastMessages.ar.trim().length > 0)
      const hasImg =
        this.enableBroadcastImage &&
        this.broadcastImageUrl &&
        this.broadcastImageUrl.trim().length > 0
      const hasLnk =
        this.enableBroadcastLink &&
        this.broadcastLinkUrl &&
        this.broadcastLinkUrl.trim().length > 0

      return hasText || hasImg || hasLnk
    },
    tableColumns() {
      return [
        // { key: 'pin', label: this.$t('*'), sortable: false },
        { key: 'image', label: this.$t('Image'), sortable: false },
        // { key: 'fullName', label: this.$t('Fullname'), sortable: false },
        // { key: 'message', label: this.$t('Message'), sortable: false },
        // { key: 'review', label: this.$t('Review'), sortable: false },
        // { key: 'updated', label: this.$t('Updated'), sortable: false },
        // { key: 'created', label: this.$t('Created'), sortable: false },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.data
        : []
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.max
        : 0
    },
    userData() {
      return store.state[STORE_MODULE_NAME].userData != null
        ? store.state[STORE_MODULE_NAME].userData.data.map(e => ({
          _id: e.userId,
          name: `${e.firstName} ${e.lastName}`,
        }))
        : []
    },
    queriedItemsUser() {
      return store.state[STORE_MODULE_NAME].userData != null
        ? store.state[STORE_MODULE_NAME].userData.max
        : 0
    },
    wsClient() {
      return store.state.websockets.wsClient[STORE_MODULE_NAME]
    },
    menuService() {
      return store.state.appConfig.menuService
    },
    chatData() {
      return store.state[STORE_MODULE_NAME].chatData != null
        ? store.state[STORE_MODULE_NAME].chatData
        : null
    },
    navbarTitle() {
      return store.state.appConfig.navbarTitle
    },
    authType() {
      if (
        this.getUserData.userType.toUpperCase()
        === this.menuService.toUpperCase()
      ) {
        return this.$t(this.menuService.toUpperCase())
      }
      return `${this.$t(this.menuService.toUpperCase())} (${this.$t(
        this.getUserData.userType.toUpperCase(),
      )})`
    },
    getUserData() {
      return localStorage.getItem('userData') != null
        ? JSON.parse(localStorage.getItem('userData'))
        : null
    },
    getFranchiseData() {
      return localStorage.getItem('franchiseData') != null
        ? JSON.parse(localStorage.getItem('franchiseData'))
        : null
    },
    getCompanyData() {
      return localStorage.getItem('companyData') != null
        ? JSON.parse(localStorage.getItem('companyData'))
        : null
    },
    getApplicationData() {
      return localStorage.getItem('applicationData') != null
        ? JSON.parse(localStorage.getItem('applicationData'))
        : null
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // Log query parameters on route change
      this.logQueryParameters()

      // Set search from order context on route change
      this.setSearchFromOrderContext()

      const Id = to.params.id // ContactID
      if (Id !== 'undefined' && Id !== undefined) {
        // WebSocket Disconnect
        const checkIsHave = store.commit(
          'websockets/checkIsHave',
          STORE_MODULE_NAME,
        )
        if (checkIsHave) {
          store.dispatch('websockets/disconnect', STORE_MODULE_NAME)
        }

        const userData = JSON.parse(localStorage.getItem('userData'))
        const applicationId = localStorage.getItem('applicationId')

        const { userType } = userData
        const chatType = to.query.type || 'roomId' // Get type from route query

        this.show = true
        this.dataId = Id
        this.chatType = chatType

        // WebSocket Connect with type parameter
        const pathname = `/Contact?type=${userType}&applicationId=${applicationId}&userId=${Id}&chatType=${chatType}`
        const params = {
          pathname,
          page: STORE_MODULE_NAME,
        }
        store.dispatch('websockets/connect', params)

        const obj = {
          roomChatId: this.dataId,
          chatType,
        }
        this.$forceUpdate()
        store
          .dispatch(`${STORE_MODULE_NAME}/getLogChat`, obj)
          // eslint-disable-next-line no-unused-vars
          .then(result => {
            this.$nextTick(() => {
              this.psToBottom()
              this.show = false
            })
            // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
            // eslint-disable-next-line no-unused-vars
          })
          .catch(error => {
            this.show = false

            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: this.$t('Error'),
                icon: 'ErrorIcon',
                variant: 'danger',
                text: this.$t(error.response.data.message),
              },
            })
            // console.log('fetchUsers Error : ', error)
            // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
          })
      } else {
        this.$store.commit(`${STORE_MODULE_NAME}/CLEAR_CHAT_DATA`)
      }
    },
  },
  created() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)

    // Log query parameters if they exist
    this.logQueryParameters()

    // Set search from order context if available
    this.setSearchFromOrderContext()

    const obj = {
      currentPage: this.currentPage,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
    }

    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/get`, obj)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        //
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        // eslint-disable-next-line no-unused-vars
      })
      .catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.getUser()
    this.initChat()
    this.typing = debounce(this.typing, 500)
    this.sendTypingWS = debounce(this.sendTypingWS, 500)

    // Auto-select first user after users are loaded
    this.$nextTick(() => {
      if (this.userData && this.userData.length > 0) {
        this.userId = this.userData[0]._id
      }
    })
  },
  destroyed() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false)
    // WebSocket Disconnect
    store.dispatch('websockets/disconnect', STORE_MODULE_NAME)
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
  },
  setup() {
    return { STORE_MODULE_NAME }
  },
  updated() {
    // WebSocket
    if (this.wsClient) {
      // ถ้าเกิดเชื่อมไม่ได้ จะเข้า onErrorก่อน หลังจากนั้นจะทำการ onClose เอง
      this.wsClient.onerror = err => {
        console.log('onError')
        console.log(err)
      }
      this.wsClient.onclose = err => {
        console.log('onClose')
        console.log(err)
      }
      this.wsClient.onmessage = msg => {
        const SocketMessage = JSON.parse(msg.data)

        console.log(SocketMessage)
        if (SocketMessage.message !== 'WS_CONNECTED') {
          if (
            SocketMessage.data.method !== 'VIEW'
            && SocketMessage.data.method !== 'UPDATE'
          ) {
            store.commit(
              `${STORE_MODULE_NAME}/SEND_MESSAGE`,
              SocketMessage.data.send.data,
            )
            this.$nextTick(() => {
              this.psToBottom()
            })
          }
        }
      }
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    getTimeAgo(inputTime) {
      const seconds = Math.floor((this.now - new Date(inputTime)) / 1000)

      if (seconds < 60) {
        return `${seconds} ${this.$t('seconds')}`
      } if (seconds < 3600) {
        return `${Math.floor(seconds / 60)} ${this.$t('minutes')}`
      } if (seconds < 86400) {
        return `${Math.floor(seconds / 3600)} ${this.$t('hours')}`
      }
      return `${Math.floor(seconds / 86400)} ${this.$t('days')}`
    },
    initChat() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const applicationId = localStorage.getItem('applicationId')
      const Id = this.$route.params.id // ContactID
      const chatType = this.$route.query.type || 'roomId' // Default to roomId if not specified

      if (Id !== 'undefined' && Id !== undefined) {
        const { userType } = userData
        this.show = true
        this.dataId = Id

        // Store chat type for API calls
        this.chatType = chatType

        // WebSocket Connect with type parameter
        const pathname = `/Contact?type=${userType}&applicationId=${applicationId}&userId=${Id}&chatType=${chatType}`
        const params = {
          pathname,
          page: STORE_MODULE_NAME,
        }
        store.dispatch('websockets/connect', params)

        // Prepare API call object with type information
        const obj = {
          roomChatId: this.dataId,
          chatType,
        }
        store
          .dispatch(`${STORE_MODULE_NAME}/getLogChat`, obj)
          // eslint-disable-next-line no-unused-vars
          .then(result => {
            this.$nextTick(() => {
              this.psToBottom()
              this.show = false

              // Check if there's order context and send initial message
              this.sendOrderContextMessage()
            })
            // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
            // eslint-disable-next-line no-unused-vars
          })
          .catch(error => {
            this.show = false

            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: this.$t('Error'),
                icon: 'ErrorIcon',
                variant: 'danger',
                text: this.$t(error.response.data.message),
              },
            })
            // console.log('fetchUsers Error : ', error)
            // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
          })
      }
    },
    openWhatsappEditModal() {
      this.whatsappNumberInput = (this.chatData && this.chatData.userInfo && this.chatData.userInfo.whatsappNumber) || ''
      this.isEditingWhatsappModal = true
    },
    handleSaveWhatsappNumber() {
      if (!this.dataId) return
      const obj = {
        roomChatId: this.dataId,
        whatsappNumber: this.whatsappNumberInput.trim(),
      }
      store.dispatch(`${STORE_MODULE_NAME}/updateWhatsappNumber`, obj)
        .then(res => {
          if (this.chatData && this.chatData.userInfo) {
            this.chatData.userInfo.whatsappNumber = this.whatsappNumberInput.trim()
          }
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Success'),
              icon: 'CheckIcon',
              variant: 'success',
              text: this.$t('ผูกเบอร์ WhatsApp เรียบร้อยแล้ว'),
            },
          })
        })
        .catch(err => {
          console.error(err)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: this.$t('ไม่สามารถบันทึกเบอร์ WhatsApp ได้'),
            },
          })
        })
    },
    inputImageRenderer(input) {
      this.show = true

      // eslint-disable-next-line prefer-destructuring
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
          const obj = {
            roomChatId: this.dataId,
            image: this.image,
            userId: this.chatData.userInfo.userId,
            type: 1,
            channel: this.sendChannel,
            whatsappPhone: (this.chatData && this.chatData.userInfo && this.chatData.userInfo.whatsappNumber) || '',
          }
          store
            .dispatch(`${STORE_MODULE_NAME}/uploadImage`, obj)
            .then(result => {
              this.chatInputMessage = ''

              this.$nextTick(() => {
                this.psToBottom()
                this.show = false
              })

              if (this.sendChannel === 'whatsapp') {
                const waStatus = result && result.data && result.data.whatsappStatus
                if (waStatus === 'sent') {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                      title: 'WhatsApp Image Sent',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: this.$t('ส่งรูปภาพไปยัง WhatsApp ลูกค้าสำเร็จแล้ว'),
                    },
                  })
                } else if (waStatus === 'failed') {
                  const waErr = (result && result.data && result.data.whatsappError) || 'Failed to deliver image to WhatsApp'
                  this.$toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                      title: 'WhatsApp Image Delivery Failed',
                      icon: 'AlertTriangleIcon',
                      variant: 'warning',
                      text: this.$t(waErr),
                    },
                  })
                }
              }
            })
            .catch(error => {
              this.show = false
              console.log('uploadImage Error : ', error)
            })
        }
        reader.readAsDataURL(input.target.files[0])
      } else {
        this.show = false
      }
    },
    review() {
      this.show = true

      const obj = {
        roomChatId: this.dataId,
      }
      store
        .dispatch(`${STORE_MODULE_NAME}/setInReview`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
        })
    },
    sendTypingWS(value) {
      console.log(value)
      if (value.trim() !== '') {
        const dataSend = {
          data: null, // ข้อมูลที่ส่ง
          page: 'CONTACT_US_ECOMMERCE', // ชื่อเมนู
        }
        const webSocketData = {
          send: dataSend,
          author: [`CONTACT_${this.dataId}`],
          method: 'VIEW',
          sendMethod: 'WAIT_DATA',
          type: 'company',
          pathname: 'Web',
        }
        const obj = {
          data: webSocketData,
          page: STORE_MODULE_NAME,
        }
        store.dispatch('websockets/sendMessage', obj)
      }
    },
    sendMessage() {
      if (this.chatInputMessage.length > 0) {
        this.show = true

        const isLink = this.chatInputMessage.trim().startsWith('http://') || this.chatInputMessage.trim().startsWith('https://')
        const messageType = isLink ? 5 : 0

        const obj = {
          roomChatId: this.dataId,
          message: this.chatInputMessage,
          userId: this.chatData.userInfo.userId,
          type: messageType,
          channel: this.sendChannel,
          whatsappPhone: (this.chatData && this.chatData.userInfo && this.chatData.userInfo.whatsappNumber) || '',
        }
        store
          .dispatch(`${STORE_MODULE_NAME}/sendMessage`, obj)
          .then(result => {
            this.chatInputMessage = ''

            this.$nextTick(() => {
              this.psToBottom()
              this.show = false
            })

            if (this.sendChannel === 'whatsapp') {
              const waStatus = result && result.data && result.data.whatsappStatus
              if (waStatus === 'sent') {
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: 'WhatsApp Sent',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: this.$t('ส่งข้อความไปยัง WhatsApp ลูกค้าสำเร็จแล้ว'),
                  },
                })
              } else if (waStatus === 'failed') {
                const waErr = (result && result.data && result.data.whatsappError) || 'Failed to deliver to WhatsApp'
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: 'WhatsApp Delivery Failed',
                    icon: 'AlertTriangleIcon',
                    variant: 'warning',
                    text: this.$t(waErr),
                  },
                })
              }
            }
          })
          .catch(error => {
            this.show = false
            console.log('sendMessage Error : ', error)
          })
      }
    },
    psToBottom() {
      const scrollEl = this.$refs.refChatLogPS.$el || this.$refs.refChatLogPS
      scrollEl.scrollTop = scrollEl.scrollHeight
    },
    refreshChatList() {
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      return store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(() => {
          this.show = false
        })
        .catch(error => {
          this.show = false
          console.error(error)
        })
    },
    handleBroadcast(bvModalEvent) {
      if (bvModalEvent) bvModalEvent.preventDefault()

      if (!this.isBroadcastFormValid) return

      this.broadcastLoading = true

      const payload = {
        recipientType: this.broadcastRecipientType,
        selectedGroups: this.broadcastSelectedGroups,
        selectedTags: this.broadcastSelectedTags,
        messages: {
          th: this.broadcastMessages.th || '',
          en: this.broadcastMessages.en || '',
          ar: this.broadcastMessages.ar || '',
        },
        message:
          this.broadcastMessages.th ||
          this.broadcastMessages.en ||
          this.broadcastMessages.ar ||
          '',
        type: 0,
        imageUrl: this.enableBroadcastImage ? this.broadcastImageUrl : '',
        linkUrl: this.enableBroadcastLink ? this.broadcastLinkUrl : '',
        linkTitle: this.enableBroadcastLink ? this.broadcastLinkTitle : '',
      }

      store
        .dispatch(`${STORE_MODULE_NAME}/broadcastMessage`, payload)
        .then(response => {
          this.broadcastLoading = false
          this.isBroadcastModalActive = false

          const summary = (response.data && response.data.summary) || {
            totalTarget: response.data && response.data.data ? response.data.data.length : 0,
            successCount: response.data && response.data.data ? response.data.data.length : 0,
            failedCount: 0,
            recipients: [],
          }

          this.broadcastSummary = summary
          this.isBroadcastSummaryModalActive = true

          // Reset form fields
          this.broadcastMessages = { th: '', en: '', ar: '' }
          this.enableBroadcastImage = false
          this.broadcastImageUrl = ''
          this.enableBroadcastLink = false
          this.broadcastLinkTitle = ''
          this.broadcastLinkUrl = ''

          this.refreshChatList()
        })
        .catch(error => {
          this.broadcastLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: this.$t(
                error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : 'Failed to broadcast message'
              ),
            },
          })
        })
    },
    onBroadcastModalShow() {
      if (this.memberGroupOptions.length === 0) {
        this.fetchMemberGroups()
      }
    },
    fetchMemberGroups() {
      axios
        .get('/api/web/application/eCommerce/memberGroup/get?pageSize=100&currentPage=1&searchQuery=')
        .then(res => {
          if (res.data && res.data.data) {
            this.memberGroupOptions = res.data.data.map(g => ({
              value: g._id,
              text: g.name || g.groupName || g._id,
            }))
          }
        })
        .catch(err => {
          console.error('Failed to load member groups', err)
        })
    },
    handleBroadcastImageUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.append('image', file)
      this.uploadingBroadcastImage = true
      store
        .dispatch(`${STORE_MODULE_NAME}/uploadImage`, formData)
        .then(res => {
          this.uploadingBroadcastImage = false
          if (res.data && res.data.data && res.data.data.url) {
            this.broadcastImageUrl = res.data.data.url
          }
        })
        .catch(err => {
          this.uploadingBroadcastImage = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: this.$t('Failed to upload image'),
            },
          })
        })
    },
    createChat() {
      // If no user is selected, automatically select the first user (index 0)
      if (!this.userId || this.userId === '') {
        if (this.userData && this.userData.length > 0) {
          this.userId = this.userData[0]._id
        } else {
          // Show error if no users available
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t('No users available to chat with'),
            },
          })
          return
        }
      }

      if (this.userId !== '' && this.userId !== null) {
        this.show = true
        store
          .dispatch(`${STORE_MODULE_NAME}/createChat`, { userId: this.userId })
          // eslint-disable-next-line no-unused-vars
          .then(result => {
            this.show = false
            const { data } = result.data
            this.$router.push({ path: `/e-commerce/chat/${data._id}` })

            // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
            // eslint-disable-next-line no-unused-vars
          })
          .catch(error => {
            this.show = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: this.$t('Error'),
                icon: 'ErrorIcon',
                variant: 'danger',
                text: this.$t(error.response.data.message),
              },
            })
            // console.log('fetchUsers Error : ', error)
            // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
          })
      }
    },
    onSearchUser(query) {
      this.searchQueryUser = query
      this.currentPageUser = 1
      this.getUser()
    },

    onUserSelect(selectedUserId) {
      if (selectedUserId) {
        // Automatically create chat when user is selected
        this.userId = selectedUserId
        this.createChat()
      }
    },

    /**
     * Logs query parameters to console if they exist
     */
    logQueryParameters() {
      const { query } = this.$route
      if (query.type || query.name) {
        console.log('ChatList.vue - Query Parameters:', {
          type: query.type,
          name: query.name,
          fullQuery: query,
        })
      }
    },

    /**
     * Sets search query from order context if available
     */
    setSearchFromOrderContext() {
      try {
        const orderContext = localStorage.getItem('chatOrderContext')
        if (orderContext) {
          const context = JSON.parse(orderContext)
          if (context.firstName) {
            console.log('ChatList.vue - Setting search from order context:', context.firstName)

            // Set both search queries
            this.searchQueryUser = context.firstName
            this.searchQuery = context.firstName

            // Perform the search and then click first chat
            this.onSearchUser(context.firstName)

            // Wait for search results and click first chat
            this.$nextTick(() => {
              this.clickFirstChatAfterSearch()
            })
          }
        }
      } catch (error) {
        console.error('Error setting search from order context:', error)
      }
    },

    /**
     * Clicks the first chat after search results are loaded
     */
    clickFirstChatAfterSearch() {
      // Wait a bit more for the search results to fully load
      setTimeout(() => {
        if (this.respData && this.respData.length > 0) {
          console.log('ChatList.vue - Clicking first chat after search:', this.respData[0])

          // Click the first chat in the list
          this.openChat(this.respData[0])

          // Send order context message after opening chat
          this.sendOrderContextMessageAfterChatOpen()
        } else {
          console.log('ChatList.vue - No search results found to click')
        }
      }, 500) // Wait 500ms for search results to load
    },

    /**
     * Sends order context message after chat is opened
     */
    sendOrderContextMessageAfterChatOpen() {
      // Wait for chat to fully load and initialize
      setTimeout(() => {
        try {
          const orderContext = localStorage.getItem('chatOrderContext')
          if (orderContext && this.dataId) {
            const context = JSON.parse(orderContext)

            console.log('ChatList.vue - Sending order context message after chat open:', context)

            // Create a formatted message with order information
            const orderMessage = `${this.$t('Order Information')}:\n${
              this.$t('Order ID')}: ${context.orderId}\n${
              this.$t('Order Code')}: ${context.orderCode}\n${
              this.$t('Status')}: ${context.orderStatus}\n${
              this.$t('Total Amount')}: ${
              (context.totalAmount / 100).toFixed(2)} ${context.currencySymbol}\n${
              this.$t('Timestamp')}: ${new Date(context.timestamp).toLocaleString()}`

            // Send the message through the chat system
            const messageObj = {
              roomChatId: this.dataId,
              message: orderMessage,
              userId: this.chatData ? this.chatData.userInfo._id : null,
              type: 0, // Text message type
              isSystemMessage: true, // Flag to indicate this is a system-generated message
              chatType: this.chatType, // Include chat type for API
            }

            // Dispatch the message to the store
            if (messageObj.userId) {
              store.dispatch(`${STORE_MODULE_NAME}/sendMessage`, messageObj)
                .then(() => {
                  console.log('ChatList.vue - Order context message sent successfully')

                  // Clear the order context after sending
                  localStorage.removeItem('chatOrderContext')

                  // Show success message
                  this.$toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                      title: this.$t('Success'),
                      icon: 'SuccessIcon',
                      variant: 'success',
                      text: this.$t('Order context message sent'),
                    },
                  })
                })
                .catch(error => {
                  console.error('Failed to send order context message:', error)
                  // Clear the order context even if sending fails
                  localStorage.removeItem('chatOrderContext')
                })
            } else {
              console.log('ChatList.vue - No userId available, cannot send order context message')
            }
          } else {
            console.log('ChatList.vue - No order context or dataId available')
          }
        } catch (error) {
          console.error('Error sending order context message after chat open:', error)
          // Clear the order context on error
          localStorage.removeItem('chatOrderContext')
        }
      }, 1000) // Wait 1 second for chat to fully load
    },

    nextPageUser(page) {
      this.currentPageUser = page
      this.userId = ''
      this.getUser()
    },
    getUser() {
      const obj = {
        currentPage: this.currentPageUser,
        pageSize: this.perPageUser,
        searchQuery: this.searchQueryUser,
        searchField: 'name', // Search by name instead of type
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/getUser`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false

          // Auto-select first user after loading users
          if (this.userData && this.userData.length > 0 && !this.userId) {
            this.userId = this.userData[0]._id
          }

          // If this was called from order context search, click first chat
          if (this.searchQueryUser && this.searchQueryUser === this.searchQuery) {
            this.$nextTick(() => {
              this.clickFirstChatAfterSearch()
            })
          }

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    pinChat(data) {
      const id = data._id
      const status = !data.pin
      const obj = {
        id,
        status,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/pinChat`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
          //
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(() => {
          this.show = false
          // this.$toast({
          //   component: ToastificationContent,
          //   position: 'bottom-right',
          //   props: {
          //     title: this.$t('Error'),
          //     icon: 'ErrorIcon',
          //     variant: 'danger',
          //     text: this.$t(error.response.data.message),
          //   },
          // })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    openChat(data) {
      this.$router.push({ path: `/e-commerce/chat/${data._id}` })
    },
    typing(value) {
      console.log(value)
      this.searchQuery = value
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/delete`, id)
              // eslint-disable-next-line no-unused-vars
              .then(result => {
                this.show = false
              })
              .catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPage(page) {
      this.currentPage = page
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
    addLink() {
      this.isLinkModalActive = true
    },
    /**
     * Sends an initial message with order context when opening chat from order detail
     * This provides context about the order being discussed
     */
    sendOrderContextMessage() {
      try {
        const orderContext = localStorage.getItem('chatOrderContext')
        if (orderContext && this.dataId) {
          const context = JSON.parse(orderContext)

          // Create a formatted message with order information
          const orderMessage = `${this.$t('Order Information')}:\n${
            this.$t('Order ID')}: ${context.orderId}\n${
            this.$t('Order Code')}: ${context.orderCode}\n${
            this.$t('Status')}: ${context.orderStatus}\n${
            this.$t('Total Amount')}: ${
            (context.totalAmount / 100).toFixed(2)} ${context.currencySymbol}\n${
            this.$t('Timestamp')}: ${new Date(context.timestamp).toLocaleString()}`

          // Send the message through the chat system
          const messageObj = {
            roomChatId: this.dataId,
            message: orderMessage,
            userId: this.chatData ? this.chatData.userInfo._id : null,
            type: 0, // Text message type
            isSystemMessage: true, // Flag to indicate this is a system-generated message
            chatType: this.chatType, // Include chat type for API
          }

          // Dispatch the message to the store
          if (messageObj.userId) {
            store.dispatch(`${STORE_MODULE_NAME}/sendMessage`, messageObj)
              .then(() => {
                // Clear the order context after sending
                localStorage.removeItem('chatOrderContext')

                // Show success message
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Success'),
                    icon: 'SuccessIcon',
                    variant: 'success',
                    text: this.$t('Order context message sent'),
                  },
                })
              })
              .catch(error => {
                console.error('Failed to send order context message:', error)
                // Clear the order context even if sending fails
                localStorage.removeItem('chatOrderContext')
              })
          }
        }
      } catch (error) {
        console.error('Error sending order context message:', error)
        // Clear the order context on error
        localStorage.removeItem('chatOrderContext')
      }
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/base/pages/app-chat-list.scss';

.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.b-col-custom {
  margin-top: 0.5rem;
}

.hide-header thead {
  display: none;
}
</style>
